/* Sunnafrucht Hero-Karte (16.10.2026). Wechselt die Produkte in der Karte oben auf der Startseite.
   Das erste Produkt kommt fertig aus snippets/sf-hero-karte.liquid. Ein neues Produkt erscheint erst,
   wenn sein Bild geladen ist, Name und Bild wechseln gleichzeitig. Der Ladebalken ist eine Animation
   und pausiert, wenn die Karte nicht zu sehen ist oder die Maus darauf liegt.
   lovable-home.js lässt die Karte in Ruhe, weil die Daten jetzt in .sf-hero__data stehen. */
(function () {
  'use strict';
  var DURATION = 3500;
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 17l-6.2 3.6 1.6-6.7L2.2 8.9l6.9-.6z"/></svg>';
  var cache = {};
  var area = document.createElement('textarea');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function plain(s) { area.innerHTML = s || ''; return area.value; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  /* Lädt und dekodiert ein Bild einmal, danach kommt es sofort aus dem Speicher */
  function load(src) {
    if (!src) return Promise.resolve(false);
    if (!cache[src]) {
      cache[src] = new Promise(function (res) {
        var im = new Image();
        var done = false;
        var t = setTimeout(function () { fin(false); }, 8000);
        function fin(ok) {
          if (done) return;
          done = true;
          clearTimeout(t);
          if (!ok) delete cache[src];
          res(ok);
        }
        im.decoding = 'async';
        im.onload = function () {
          if (im.decode) im.decode().then(function () { fin(true); }, function () { fin(im.naturalWidth > 0); });
          else fin(im.naturalWidth > 0);
        };
        im.onerror = function () { fin(false); };
        im.src = src;
      });
    }
    return cache[src];
  }
  function ratingHtml(s) {
    var n = parseInt(s.reviews, 10) || 0;
    if (n < 1) return '';
    return '<span class="lvh-stars" aria-hidden="true">' + STAR + STAR + STAR + STAR + STAR + '</span><span class="lvh-hcard2__rcount">(' + n + ')</span>';
  }
  function flagsHtml(s) {
    var h = '';
    if (s.flag1) h += '<img class="lvh-hcard2__flagimg" src="' + esc(s.flag1) + '" alt="" height="14">';
    if (s.flag2) h += '<img class="lvh-hcard2__flagimg" src="' + esc(s.flag2) + '" alt="" height="14">';
    if (s.flagLabel) h += '<span class="lvh-hcard2__flaglabel">' + esc(s.flagLabel) + '</span>';
    if (!h && s.flags) h = '<span class="lvh-hcard2__flaglabel">' + esc(s.flags) + '</span>';
    return h;
  }

  function init(root) {
    if (!root || root._sfHero) return;
    var card = root.querySelector('[data-lvh-hero-card]');
    var data = root.querySelector('.sf-hero__data');
    if (!card || !data) return;
    var slides;
    try { slides = JSON.parse(data.textContent) || []; } catch (e) { return; }
    if (!slides.length) return;
    root._sfHero = true;
    function q(s) { return card.querySelector(s); }
    var img = q('[data-hero-img]');
    var hov = q('[data-hero-hover]');
    var off = q('[data-hero-off]');
    var nameEl = q('[data-hero-name]');
    var rating = q('[data-hero-rating]');
    var size = q('[data-hero-size]');
    var now = q('[data-hero-now]');
    var was = q('[data-hero-was]');
    var unit = q('[data-hero-unit]');
    var flags = q('[data-hero-flags]');
    var count = q('[data-hero-count]');
    var bar = q('[data-hero-bar]');
    var dots = [].slice.call(card.querySelectorAll('.lvh-hcard2__dot'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = !reduce && slides.length > 1;
    var idx = 0, token = 0, hover = false, inView = true, anim = null, timer = 0;

    function paused() { return hover || !inView || document.hidden; }
    function setPaused() {
      var p = paused();
      card.classList.toggle('is-paused', p);
      if (anim) {
        if (p) anim.pause();
        else if (anim.playState === 'paused') anim.play();
      }
    }
    function startBar() {
      if (anim) { anim.onfinish = null; anim.cancel(); anim = null; }
      clearTimeout(timer);
      if (!auto) return;
      if (bar && bar.animate) {
        anim = bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: DURATION, easing: 'linear', fill: 'forwards' });
        anim.onfinish = function () { go(idx + 1, false); };
        if (paused()) anim.pause();
      } else {
        timer = setTimeout(function () { go(idx + 1, false); }, DURATION);
      }
    }
    function showHover() {
      var s = slides[idx];
      var my = token;
      if (!hov || !s.hoverImg || s.hoverImg === s.img) return;
      load(s.hoverImg).then(function (ok) {
        if (!ok || my !== token || !hover) return;
        hov.src = s.hoverImg;
        hov.classList.add('is-ready');
      });
    }
    function show(i) {
      var s = slides[i];
      var sale = Number(s.was) > Number(s.price);
      idx = i;
      if (hov) { hov.classList.remove('is-ready'); hov.removeAttribute('src'); }
      if (img) {
        img.src = s.img;
        img.alt = s.name || '';
        if (img.animate) img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 500, easing: 'ease' });
      }
      if (off) { off.textContent = s.off > 0 ? '-' + s.off + '%' : ''; off.style.display = s.off > 0 ? '' : 'none'; }
      if (nameEl) nameEl.textContent = s.name || '';
      if (rating) rating.innerHTML = ratingHtml(s);
      if (size) size.textContent = String(s.sub || '').split('·')[0].trim();
      if (now) { now.textContent = plain(s.nowText); now.classList.toggle('is-sale', sale); }
      if (was) { was.textContent = sale ? plain(s.wasText) : ''; was.style.display = sale && s.wasText ? '' : 'none'; }
      if (unit) unit.textContent = plain(s.unitPriceText);
      if (flags) flags.innerHTML = flagsHtml(s);
      if (s.href) card.setAttribute('href', s.href);
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (hover) showHover();
    }
    /* Wechsel erst, wenn das Bild bereit ist (höchstens 6 s warten, nach Klick 1,5 s) */
    function go(i, user) {
      var n = slides.length;
      var my = ++token;
      i = (i % n + n) % n;
      Promise.race([load(slides[i].img), wait(user ? 1500 : 6000)]).then(function () {
        if (my !== token) return;
        show(i);
        startBar();
        load(slides[(i + 1) % n].img);
      });
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (k !== idx) go(k, true);
      });
    });
    card.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      hover = true;
      setPaused();
      showHover();
    });
    card.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      hover = false;
      setPaused();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        inView = en[en.length - 1].isIntersecting;
        setPaused();
      }, { threshold: 0.15 }).observe(card);
    }
    document.addEventListener('visibilitychange', setPaused);

    load(slides[0].img);
    if (slides.length > 1) load(slides[1].img);
    startBar();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-lvh-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-lvh-hero]') : null;
    if (r) init(r);
  });
})();